import { hasJSONResponse, setFormikUiErrors, SettingsType, validationResultsToUiError } from "adviesbox-shared";
import { FormikContextType } from "formik";
import { User } from "oidc-client";
import { WoningenOutput } from "../../.generated/forms/formstypes";
import { target2field } from "../../shared/utils/target-to-field";
import { WoningState } from "../infra/woning-schema";
export const uploadFotoVanWoningApi = async (
  settings: SettingsType,
  user: User | null,
  vestigingId: string,
  adviesdossierId: string,
  body: FormData,
  formik: FormikContextType<WoningState>
): Promise<any> => {
  const url = `${settings.klantdossiersFormsOrigin}/Woning/UploadFotoWoning?adviesdossierId=${adviesdossierId}`;

  if (!settings.klantdossiersFormsOrigin) {
    throw new Error("Missing klantdossiersFormsOrigin setting");
  }
  if (!vestigingId) {
    throw new Error("Missing vestigingId parameter");
  }
  if (!adviesdossierId) {
    throw new Error("Missing adviesdossierId parameter");
  }
  if (!user?.access_token) {
    throw new Error("Missing user access token");
  }

  const rsp = await fetch(url, {
    method: "POST",
    body,
    headers: {
      Accept: "*/*",
      "Ocp-Apim-Subscription-Key": settings.OcpApimSubscriptionKey,
      authorization: `${user?.token_type} ${user?.access_token}`,
      vestigingId
    }
  });

  // Try to get response text for debugging
  const responseClone = rsp.clone();
  let responseText = "";
  try {
    responseText = await responseClone.text();
  } catch (e) {
    // Could not read response text
  }

  formik.setFieldValue("platformApiFouten", null);

  if (!rsp.ok) {
    let json: any = null;
    try {
      json = await rsp.json();
    } catch (jsonError) {
      // Could not parse error response as JSON
      // Raw error response logged
    }

    if (json?.validationResults?.length)
      setFormikUiErrors(
        validationResultsToUiError(json.validationResults, (target: any) => target2field({}, target)),
        formik
      );
    else
      formik.setFieldValue("platformApiFouten", [
        {
          field: "",
          label: "Op te nemen foto",
          error: json?.message ?? responseText ?? "Fout bij aanroep van web-api"
        }
      ]);

    const errorMessage = json?.message || responseText || `HTTP ${rsp.status} ${rsp.statusText}`;
    throw Error(`Fout bij aanroep van web-api '${url}': ${errorMessage}`);
  }

  return true;
};

export const getBlobUrlApi = async (
  settings: SettingsType,
  user: User | null,
  vestigingId: string,
  adviesdossierId: string,
  isHuidigeWoning: boolean
): Promise<string> => {
  const url = `${settings.klantdossiersFormsOrigin}/Adviesdossiers/${adviesdossierId}/Woning`;

  const rsp = await fetch(url, {
    method: "GET",
    headers: {
      authorization: `${user?.token_type} ${user?.access_token}`,
      "Ocp-Apim-Subscription-Key": settings.OcpApimSubscriptionKey,
      "Content-Type": "application/json;charset=UTF-8",
      vestigingId
    }
  });

  if (!(rsp.ok && hasJSONResponse(rsp))) {
    throw Error(`Fout bij aanroep van web-api '${url}'. Resultaat bevat geen JSON.`);
  }

  const json: WoningenOutput = await rsp.json();

  if (!json.isValid) {
    throw Error(`Fout bij aanroep van web-api '${url}'. Input is niet valid.`);
  }
  const woningen = json?.woningen;
  const woningValues = woningen ? Object.values(woningen) : [];
  const firstWoning = woningValues[0];
  const huidigeWoningIndex = isHuidigeWoning
    ? firstWoning?.huidigeWoningen?.findIndex(hw => hw.pandId === firstWoning.hypotheekOpWoning)
    : null;

  const locatieFoto =
    huidigeWoningIndex !== null &&
    huidigeWoningIndex !== undefined &&
    firstWoning?.huidigeWoningen?.[huidigeWoningIndex]
      ? firstWoning.huidigeWoningen[huidigeWoningIndex]?.locatieFoto
      : firstWoning?.aanTeKopenWoning?.pand?.locatieFoto;
  const result = locatieFoto ?? "";

  return result;
};
